import { WATCH_TEAMS } from "../actionTypes";

export const watchteamsfunc = (data) => 
{
    return {
        type: WATCH_TEAMS,
        data: data,
    }
}